import { BRAND_NAMES } from "@/app/utils/utils";
import { Car } from "lucide-react";

export default function GenuineParts() {
  return (
    <section className="max-w-7xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
      <div className="flex items-center gap-3 mb-6">
        <Car className="w-8 h-8 text-red-600" />
        <h1 className="text-3xl font-semibold text-gray-900">Peças genuínas</h1>
      </div>
      <p className="text-gray-600 leading-relaxed max-w-4xl">
        Nas concessionárias {BRAND_NAMES.DEFAULT} a excelência da manutenção do
        seu veículo é garantida com a utilização exclusiva de peças genuínas.
        Fabricadas especialmente para o seu carro e seguindo o Padrão de
        Qualidade Toyota, as peças são disponibilizadas em nossas
        concessionárias, usando o sistema Just in Time. Tudo para oferecer o
        melhor em manutenção, aumentar ainda mais a durabilidade do seu veículo
        e ajudar a sistema Just in Time. Tudo para oferecer o melhor em
        manutenção, aumentar ainda mais a durabilidade do seu veículo e ajudar a
        preservar o meio ambiente.
      </p>
    </section>
  );
}
